import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { decode } from "he";
import "./Services.css";
import { baseURl } from "../../config";
import {fixImagePaths} from "../util"
import { useSelector } from "react-redux";

const Services = () => {
  const [servicesData, setServicesData] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [visibleCount, setVisibleCount] = useState(6);
  const navigate = useNavigate();
  const {services} = useSelector((state) => state.data);

  useEffect(() => {
 
  setServicesData(services);

  }, []);

  const toggleVisibility = () => {
    setVisibleCount((prevCount) =>
      prevCount === servicesData.length ? 6 : servicesData.length
    );
  };

  const handleLearnMore = (service) => {
    localStorage.setItem("selectedServiceId", service._id); // Store ID
    navigate(`/service-description/${service._id}`, { state: { service } });
  };

  const columnsPerRow = 3;
  const totalDisplayed = Math.min(servicesData.length, visibleCount);
  const emptySlots = (columnsPerRow - (totalDisplayed % columnsPerRow)) % columnsPerRow;

  return (
    <section id="services" className="services-section">
      <div className="services-header">
        <h2>
          {selectedService ? selectedService.title : "Our Services"}
        </h2>
        <p>Discover the services we offer to meet your business's needs.</p>
      </div>
      <div className="services-container">
        {servicesData.slice(0, visibleCount).map((service, index) => (
          <div key={index} className="service-card">
            <img
              src={service.image}
              alt={service.title}
              className="service-image"
              onError={(e) => {
                console.error(`Image failed to load: ${e.target.src}`);
                e.target.src = "/placeholder-image.jpg";
              }}
            />
            <div className="service-content">
              <h3>{service.title}</h3>
              <div className="service-description">
                <div dangerouslySetInnerHTML={{ __html: fixImagePaths(decode(service.description)) }} />
              </div>
              <button className="learn-more" onClick={() => handleLearnMore(service)}>
                Learn More
              </button>
            </div>
          </div>
        ))}

        {emptySlots > 0 && (
          <div className="service-card special-card">
            <div className="service-content">
              <h3>Currently, we have {totalDisplayed} services available.</h3>
              <p>Check back later for more updates.</p>
            </div>
          </div>
        )}
      </div>

      {services.length > 6 && (
        <button className="show-more" onClick={toggleVisibility}>
          {visibleCount === services.length ? "Show Less" : "Show More"}
        </button>
      )}
    </section>
  );
};

export default Services;